import React from 'react'
import QuizView from 'components/quiz'
import EditAssessment from 'components/quiz/edit-assessment'
import PreviewAssessment from 'components/quiz/preview'
import ReviewAssessment from 'components/quiz/review'
import StandardsResult from 'components/quiz/standards-results'
import TakeAssessment from 'components/quiz/take'
import PreviewResultsAssessment from 'components/quiz/preview-results'
import {Consumer} from 'context'
import './quiz.styl'
import ImportedTeacherTest from 'components/imported-assessment/teacher-test'


export default function QuizPage() {
  return (<Consumer>{context => {
    return (<React.Fragment>
      {context.attemptId && <ImportedTeacherTest key={context.attemptId} context={context} />}
      {context.tab && !context.attemptId && <QuizView context={context} />}
      {context.assessment && context.action == 'edit' && <EditAssessment context={context} />}
      {context.assessment && context.action == 'preview' && <PreviewAssessment context={context} />}
      {context.assessment && context.action == 'review' && <ReviewAssessment context={context} />}
      {context.assessment && context.action == 'standards-results' && <StandardsResult context={context} />}
      {context.assessment && context.action == 'take' && <TakeAssessment context={context} />}
      {context.assessment && context.action == 'preview-results' && <PreviewResultsAssessment context={context} />}
    </React.Fragment>)
  }}</Consumer>)
}

